module.exports = __webpack_public_path__ + "assets/img/extreme-mob.43c3e152.png";